import React from "react";
import { motion } from "framer-motion";
import { transition1 } from "../transitions";
import ExpandiableModel from "../components/expandiableModel";

const About = () => {
  return (
    <>
      <motion.section
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: "100%" }}
        transition={transition1}
        className="pt-24 lg:pt-2 justify-center items-center bg-zinc-800"
      >
        {/* <div className='w-screen lg:h-300 py-6 text-center lg:text-left bg-white h2 lg:px-40 lg:pt-40 lg:pb-14'>About Us</div> */}
        <div className="bg-zinc-800 flex-grow">
          <div className="lg:flex items-center justify-center  flex-2 lg:p-40 text-gray-200">
            <div className="lg:text-start text-center  pt-10 pb-8 lg:pb-0 lg:pt-0 lg:pl-8 flex-1">
              <p className="lg:h3 h4">Board Constellation</p>
              <br />
              <hr className="border-t hidden lg:flex border-2  lg:w-1/2 border-white  mb-4" />
              <p className="text-md lg:text-justify px-10 lg:px-0 lg:pr-24 text-gray-350">
                Mundus Axis is a contemporary reimagining of the world’s center.
                Cartographies of Flux maps the ever-shifting geographies of
                displacement, identity, resistance, and belonging—where borders
                dissolve, anthropocentric systems are confronted, and new worlds
                emerge through movement, memory, horizontal learning, and
                radical imagination. A platform for artists, writers,
                researchers, and cultural workers who challenge
                borders—geographic, political, gendered, and symbolic. <br/>Rooted in
                decolonial and ecological thought, Mundus Axis is a moving
                constellation—born of rupture and reworlding—where creativity
                becomes radical imagination.
              </p>
            </div>
            <div className="pl-8 items-center justify-center lg:pl-0">
              <hr className="border-t pl lg:hidden self-center hidden border-2 border-white w-1/2 my-6" />
            </div>
            <div className="flex-1 ">
              <div className="flex items-center justify-center w-full flex-wrap">
                <ExpandiableModel />
                {/* {images.map((image, index) => (
                  <img
                    key={index}
                    className=" pointer-events-auto cursor-pointer rounded-full m-5 h-28 lg:h-32 transform hover:scale-110 transition-transform duration-500"
                    src={image}
                    alt={`portrait ${index}`}
                  />
                ))} */}
              </div>
            </div>
          </div>
        </div>
      </motion.section>
      {/* <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='pb-24 lg:pb-28 bg-zinc-800 overflow-auto'
    >
      
    <div className='w-screen lg:h-300 py-6 text-center lg:text-left bg-white h2 lg:px-40 lg:pt-40 lg:pb-14'>About Us</div> 
    <div className='bg-zinc-800'>
    <div className='lg:flex  flex-2 lg:px-40 text-gray-200'>
        
       

        <div className='lg:h3 h4 lg:pt-0 pt-10 lg:pt-0 pl-8 flex-1'>
            Mundus Axis <br/>
            Cartographies of Flux<br/>
            <hr className="border-t hidden lg:flex border-2 w-1/2 border-white  my-6" />

        </div>
        <div className='pl-8 lg:pl-0'>
        <hr className="border-t pl lg:hidden border-2 border-white w-1/2 my-6" />
        </div>
        <div className='flex-1 px-14'>
            <p className='text-md'>Mundus Axis is a contemporary reimagining of the world’s center. Cartographies of Flux maps the ever-shifting geographies of displacement, identity, resistance, and belonging—where borders dissolve, anthropocentric systems are confronted, and new worlds emerge through movement, memory, horizontal learning, and radical imagination.
A platform for artists, writers, researchers, and cultural workers who challenge borders—geographic, political, gendered, and symbolic. Rooted in decolonial and ecological thought, Mundus Axis is a moving constellation—born of rupture and reworlding—where creativity becomes radical imagination.
        </p>
        </div>
    </div>
    </div>
    </motion.section> */}
    </>
  );
};

export default About;
